import { faLockKeyhole } from '@fortawesome/pro-light-svg-icons/faLockKeyhole'
import React from 'react'
import Icon from 'src/components/Icon'
import i18n from 'src/i18n'

const CommentInputBlockState: React.FC = () => {
  return (
    <div className="_d-flex _align-items-center">
      <Icon icon={faLockKeyhole} className="_mr-2" />
      <p className="_mb-0 _font-weight _text-gray-600 _text-2">
        {i18n.t('pin_post.comment_blocked_tag')}
      </p>
    </div>
  )
}

export default CommentInputBlockState
